import { parseToHtml } from '@finn/ui-utils';
import React, { ElementType } from 'react';

import { TestimonialCosmicMetadata } from './Testimonial.types';

type Props = {
  data: TestimonialCosmicMetadata;
};

const TestimonialDescription: React.FC<Props> = ({ data }) => {
  const TitleEl = (data?.tag || 'h2') as ElementType;

  return (
    <div className="mr-9 flex flex-col gap-9">
      <TitleEl className="mobile-t3-semibold sm:web-t3-semibold">
        {parseToHtml(data.title)}
      </TitleEl>

      <div className="body-16-light">{data.description}</div>
    </div>
  );
};

export default React.memo(TestimonialDescription);
